module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/jpmc-cf952864a8c28798e347ff1ee32b472d.png";